import React from 'react';

export const AuthNavbar = () => {
  return (
    <div className="bg-white shadow">
      <div className="max-w-7xl w-full flex mx-auto justify-center  px-4 sm:px-6 lg:px-8 py-5">
        GreenLight
      </div>
    </div>
  );
};
